<template>
    <div class="main" style="">
        <div style="position: relative">
            <h3 style="font-size:16px;text-shadow: none;font-weight: 400;line-height: 27px;margin:0px;">
                Blocks
            </h3>
            <i @click="init()" class="el-icon-refresh" style="font-size: 23px;cursor: pointer;position: absolute;right: 0;top: 2px"></i>
        </div>
        <div style="position: relative">
            <table style="width:100%;max-width: 100%;margin-bottom: 20px;border-spacing: 0;">
                <thead>
                <tr style="border-color: #E1E1E1; border-width: 1px; background-color: #F9F9F9; border-top-style: solid;">
                    <th>Height</th>
                    <th>Age</th>
                    <th>txn</th>
                    <th>Miner</th>
                    <th>GasUsed</th>
                    <th>GasLimit</th>
                    <th>Size</th>
                    <th>Total Difficulty</th>
                    <!--<th>Reward</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="block in blockList">
                    <td>
                        <a @click="changeRoute('/blockDetail', {number: block.number})">{{ block.number }}</a>
                    </td>
                    <td>
                        <span> {{ block.timestamp | time2Date}}</span>
                    </td>
                    <td>
                        <a @click="changeRoute('/transactionList', {number: block.number})">{{ block.transactions.length }}</a>
                    </td>
                    <td>
                        ETSC_Miner
                        <!--<a href="/home/index/usertrans/address/0x0000000000000000000000000000000000000000.html">0x0000000000000000000000000000000000000000</a>-->
                    </td>
                    <td>{{ block.gasUsed | fmoney }}</td>
                    <td>{{ block.gasLimit | fmoney }}</td>
                    <td>{{ block.size | fmoney }} bytes</td>
                    <td>{{ block.totalDifficulty | fmoney }}</td>
                </tr>
                </tbody>
            </table>
            <LoadingV></LoadingV>
            <div @click="getMore()" v-show="!isEnd && !loadingV.show" style="width: 100%;text-align: center;cursor: pointer">load more</div>
            <!--<div class="yahoo2">
                <div><span class="current">1</span><a class="num"
                                                      href="http://www.etscscan.io/home/index/blocklist/p/2.html">2</a><a
                        class="num" href="http://www.etscscan.io/home/index/blocklist/p/3.html">3</a><a class="num"
                                                                                                         href="http://www.etscscan.io/home/index/blocklist/p/4.html">4</a><a
                        class="num" href="http://www.etscscan.io/home/index/blocklist/p/5.html">5</a><a class="num"
                                                                                                         href="http://www.etscscan.io/home/index/blocklist/p/6.html">6</a><a
                        class="num" href="http://www.etscscan.io/home/index/blocklist/p/7.html">7</a><a class="num"
                                                                                                         href="http://www.etscscan.io/home/index/blocklist/p/8.html">8</a><a
                        class="num" href="http://www.etscscan.io/home/index/blocklist/p/9.html">9</a><a class="num"
                                                                                                         href="http://www.etscscan.io/home/index/blocklist/p/10.html">10</a><a
                        class="num" href="http://www.etscscan.io/home/index/blocklist/p/11.html">11</a> <a class="next"
                                                                                                            href="http://www.etscscan.io/home/index/blocklist/p/2.html">&gt;&gt;</a>
                    <a class="end" href="http://www.etscscan.io/home/index/blocklist/p/259502.html">259502</a></div>
            </div>-->
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "blockList",
        data() {
            return {
                blockList: [],
                params: {
                    pageNo: 1,
                    pageSize: 20
                },
                isEnd: false
            }
        },
        mounted() {
            this.params.pageNo = 1;
            this.blockList = [];
            this.init();
        },
        watch: {
            '$route'(to, from) {
                if(to.name == from.name) {
                    this.init();
                }
            }
        },
        methods: {
            init() {
                this.isEnd = false;
                this.blockList = [];
                this.params.pageNo = 1;
                this.getBlockList();
            },
            //投注
            getBlockList() {
                if (this.isEnd) return;
                this.aLoadingV({show: true});
                return axios.get(this.requestConfig.apiHost + '/client/explore/block/list', {
                    params: this.params
                }).then((response) => {
                    this.aLoadingV({show: false});
                    if (response.data.error_code != 0) {
                        throw new Error("get list error");
                    }
                    if (response.data.data.length < 20) this.isEnd = true;
                    this.blockList = this.blockList.concat(response.data.data);
                }).catch((error) => {
                    this.aLoadingV({show: false});
                    console.log(error);
                });
            },
            getMore() {
                this.params.pageNo++;
                return this.getBlockList();
            },
        }
    }
</script>

<style scoped>
    .main {
        width: 1200px;
        margin: 0 auto;
    }

    table {
        padding: 10px 0px;
    }

    table tr th, table tr td {
        text-align: left;
        padding: 8px;
        line-height: 1.42857143;
        vertical-align: top;
        font-size: 13px;
        border-top: 1px solid #ddd;
    }

    table tr td a {
        color: #3498db;
        text-decoration: none;
    }

    table tr td a:hover {
        text-decoration: underline;
        text-decoration-color: #3498db;
    }
</style>
